module.exports = __webpack_public_path__ + "img/montepio.fb81cd76.svg";